import type { Permission } from '@ztechapps/common.contract'

export const paymePermissions = {
  app: {
    canAccess: {
      value: 'app.canAccess',
      label: 'Can Access',
      description: 'Set the permission of the user whether to enable access to application or not',
    } satisfies Permission,
  },
}
